import FadeSlider from './FadeSlider';

export default FadeSlider;



// WEBPACK FOOTER //
// ./scripts/blocks/FadeSlider/index.js